import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
var _this = null;
var routerChanged = false;

var popStateFn = function popStateFn(e) {
  // historyPop的时候需要调用getInitialProps
  routerChanged = true; // 使用popStateFn保存函数防止addEventListener重复注册,排除hashchange的情况

  if (!location.hash && _this && _this.getInitialProps) {
    _this.getInitialProps();
  }
};

function GetInitialProps(WrappedComponent) {
  var GetInitialPropsClass = /*#__PURE__*/function (_Component) {
    _inherits(GetInitialPropsClass, _Component);

    var _super = _createSuper(GetInitialPropsClass);

    function GetInitialPropsClass(props) {
      var _this2;

      _classCallCheck(this, GetInitialPropsClass);

      _this2 = _super.call(this, props);
      _this2.state = {
        extraProps: {}
      };

      if (!routerChanged) {
        routerChanged = !window.__USE_SSR__ || props.history && props.history.action === 'PUSH';
      }

      if (window.__USE_SSR__) {
        _this = _assertThisInitialized(_this2); // 修正_this指向，保证_this指向当前渲染的页面组件

        window.addEventListener('popstate', popStateFn);
      }

      return _this2;
    }

    _createClass(GetInitialPropsClass, [{
      key: "componentDidMount",
      value: function () {
        var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this.props.history && this.props.history.action !== 'POP' || !window.__USE_SSR__)) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return this.getInitialProps();

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function componentDidMount() {
          return _componentDidMount.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: "getInitialProps",
      value: function () {
        var _getInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var props, extraProps;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // csr首次进入页面以及csr/ssr切换路由时才调用getInitialProps
                  props = this.props;

                  if (!WrappedComponent.preload) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 4;
                  return WrappedComponent.preload();

                case 4:
                  WrappedComponent = _context2.sent.default;

                case 5:
                  if (!WrappedComponent.getInitialProps) {
                    _context2.next = 11;
                    break;
                  }

                  _context2.next = 8;
                  return WrappedComponent.getInitialProps(props);

                case 8:
                  _context2.t0 = _context2.sent;
                  _context2.next = 12;
                  break;

                case 11:
                  _context2.t0 = {};

                case 12:
                  extraProps = _context2.t0;
                  this.setState({
                    extraProps: extraProps
                  });

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function getInitialProps() {
          return _getInitialProps.apply(this, arguments);
        }

        return getInitialProps;
      }()
    }, {
      key: "render",
      value: function render() {
        // 只有在首次进入页面需要将window.__INITIAL_DATA__作为props，路由切换时不需要
        return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, this.props, routerChanged ? {} : window.__INITIAL_DATA__, this.state.extraProps));
      }
    }]);

    return GetInitialPropsClass;
  }(Component);

  return withRouter(GetInitialPropsClass);
}

export default GetInitialProps;